export const logEvent = {OPEN:'OPEN', ANSWER:'ANSWER', EVALUATE:'EVALUATE', CONTENTS:'CONTENTS'};
// Note to any interested students: there is no logging active! The infrastructure is here in case I want to deploy to the public!


export function log(d) {
    try {
        for (const k of ['event','label']) 
            if (d[k] == null) 
                throw new BadLog(`Log message should have key ${k}`);
        if (!(d.event in logEvent)) 
            throw new BadLog(`Unrecognized log event ${d.event}`);
    }
    catch (e) {
        console.log(e.message);
    }
    const csrftoken = getCookie('csrftoken');
    const headers = {'Content-Type': 'application/json;charset=utf-8', 'X-CSRFToken': csrftoken};
    const body = JSON.stringify(d);
    //fetch('/log', { method: 'POST', body, headers });
}

class BadLog extends Error {
    constructor(msg) { super(msg); }
}

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}
